module.exports = __webpack_public_path__ + "img/workContents03_sp_04.002315df.png";